import type { FC } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { AccountBalanceOutline, ChevronRight } from '@eqi-investimentos/icons/web';
import { Box, Button, Flex, Link, Text } from '@eqi-investimentos/react';
import { appsStoreLinks } from '@/config/appsStoreLinks';
import { Thumb } from '@/components/atoms/Thumb';
import { OpenAccountDrawer } from '@/components/molecules/OpenAccountDrawer';
import { IfRender } from '@/utils/jsx';
import { IOS_USER_AGENT_REGEX } from '@/utils/regex';
export const AppsAndBrokersSection: FC<AppsAndBrokersSectionProps> = ({
  balance
}) => {
  const {
    t
  } = useTranslation('common');
  return <Flex flexDir="column" gap="m" data-sentry-element="Flex" data-sentry-component="AppsAndBrokersSection" data-sentry-source-file="AppsAndBrokersSection.tsx">
      <IfRender condition={balance === 0} data-sentry-element="IfRender" data-sentry-source-file="AppsAndBrokersSection.tsx">
        <Flex flexDir="row" justify="space-between" borderBottom="1px solid border.secondary" data-sentry-element="Flex" data-sentry-source-file="AppsAndBrokersSection.tsx">
          <Flex gap="xs" data-sentry-element="Flex" data-sentry-source-file="AppsAndBrokersSection.tsx">
            <AccountBalanceOutline w={24} h={24} color="content.brand" data-sentry-element="AccountBalanceOutline" data-sentry-source-file="AppsAndBrokersSection.tsx" />
            <Text size="xl" color="content.secondary" data-sentry-element="Text" data-sentry-source-file="AppsAndBrokersSection.tsx">
              {t('screens.invest.appsBrokers.conectBrokers')}
            </Text>
          </Flex>

          <ChevronRight w={24} h={24} color="content.brand" data-sentry-element="ChevronRight" data-sentry-source-file="AppsAndBrokersSection.tsx" />
        </Flex>
      </IfRender>
      <Box px="2xl" w="full" data-sentry-element="Box" data-sentry-source-file="AppsAndBrokersSection.tsx">
        <OpenAccountDrawer screen="invest" customButton={<Flex flexDir="row" justify="space-between" cursor="pointer" py="s" borderBottom="1px solid" borderColor="border.secondary">
              <Flex gap="xs">
                <Thumb src="/assets/eqi-logo.svg" width={24} height={24} fit="cover" alt="Logotipo quadrado com o fundo laranja e as letras EQI em preto" />
                <Text size="xl" color="content.secondary">
                  {t('screens.invest.appsBrokers.eqiBroker')}
                </Text>
              </Flex>

              <ChevronRight w={24} h={24} color="content.brand" />
            </Flex>} data-sentry-element="OpenAccountDrawer" data-sentry-source-file="AppsAndBrokersSection.tsx" />
        <Link href={getAppStoreLinkByOS()} target="_blank" rel="noopener noreferrer" display="flex" alignItems="center" justifyContent="space-between" py="s" w="full" borderBottom="1px solid" borderColor="border.secondary" data-sentry-element="Link" data-sentry-source-file="AppsAndBrokersSection.tsx">
          <Flex alignItems="center" w="full" gap="xs" data-sentry-element="Flex" data-sentry-source-file="AppsAndBrokersSection.tsx">
            <Thumb src="/assets/eqi_trader.svg" width={24} height={24} fit="cover" alt="Logotipo quadrado com o fundo verde claro e as letras EQI em verde escuro" data-sentry-element="Thumb" data-sentry-source-file="AppsAndBrokersSection.tsx" />
            <Text size="xl" color="content.secondary" data-sentry-element="Text" data-sentry-source-file="AppsAndBrokersSection.tsx">
              {t('screens.invest.appsBrokers.eqiTrader')}
            </Text>
          </Flex>
          <ChevronRight w={24} h={24} color="content.brand" data-sentry-element="ChevronRight" data-sentry-source-file="AppsAndBrokersSection.tsx" />
        </Link>
      </Box>
    </Flex>;
};
const getAppStoreLinkByOS = () => {
  const isIOS = IOS_USER_AGENT_REGEX.test(navigator.userAgent);
  if (isIOS) {
    return appsStoreLinks.eqi.trader.ios;
  }
  return appsStoreLinks.eqi.trader.android;
};
type AppsAndBrokersSectionProps = {
  balance: number;
};